var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.64 7.25"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.86,3.16a.55.55,0,0,1,.49.48V6.79A.58.58,0,0,1,6,7.31l-.48.16a2.66,2.66,0,0,1-.79.12H2.36a2.66,2.66,0,0,1-.79-.12l-.48-.16A.58.58,0,0,1,.7,6.79V3.64a.48.48,0,0,1,.41-.48h.8v-1C1.91,1,2.45.34,3.53.34S5.1,1,5.14,2.06H4.33V2a.77.77,0,0,0-.8-.88A.77.77,0,0,0,2.72,2V3.16Z",
    transform: "translate(-0.7 -0.34)"
  })));
}

export default SvgUnlocked;